import JSZip from 'jszip';
import { downloadFromABlob } from '../../../../services/download/downloadFromABlob';

export const downloadZipFiles = async (files) => {
  const zip = new JSZip();
  const failedFiles = [];
  const fetchFiles = files.map(async (file) => {
    try {
      if (file && file.url && file.url != null) {
        const response = await fetch(file.url);
        const blob = await response.blob();
        const fileName = `${file.id}_${file.name}`;
        zip.file(fileName, blob);
      }
    } catch (error) {
      failedFiles.push(file.name);
    }
  });

  await Promise.all(fetchFiles);
  const zipBlob = await zip.generateAsync({ type: 'blob' });
  downloadFromABlob(zipBlob, 'documentos', 'zip');
  return failedFiles;
};
